import { c as _c } from "react/compiler-runtime";
import { EntityName } from 'record-it-time-common/EntityName';
import { useEntitiesChangedListener } from '../useEntitiesChangedListener/useEntitiesChangedListener';
export function useEntityChangedListener(entityName, callback) {
  const $ = _c(2);
  let t0;
  if ($[0] !== entityName) {
    t0 = [entityName];
    $[0] = entityName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEntitiesChangedListener(t0, callback);
}